import * as React from 'react';
const StreetCentsIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill={props.color}
        d="M10 1.364c-4.963 0-9 4.038-9 9 .452 11.924 17.55 11.92 18 0 0-4.962-4.037-9-9-9Zm.75 12.75v.75c-.004.981-1.496.98-1.5 0v-.75h-.201c-.8 0-1.547-.43-1.948-1.124a.75.75 0 1 1 1.297-.752.752.752 0 0 0 .65.376h1.701c.748.049 1.082-1.162.267-1.32l-2.28-.38c-2.627-.487-2.062-4.315.513-4.3v-.75c.005-.98 1.496-.98 1.5 0v.75h.201c.8 0 1.548.432 1.949 1.125a.75.75 0 0 1-1.298.751.753.753 0 0 0-.65-.375H9.25c-.748-.049-1.082 1.163-.267 1.32l2.28.38c2.627.487 2.062 4.314-.513 4.3Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M1 1.364h18v18H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default StreetCentsIcon;
